export default {
  item: {
    age: {
      title: 'Alter',
      year: 'Jahr | Jahre'
    },
    duration: {
      title: 'Dauer',
      day: 'Tag | Tage',
      night: 'Nacht | Nächte',
      one: "eine",
    },
    accommodation: {
      checkin: 'Anreise',
      checkout: 'Abreise',
      travelDate: "Ihr Reisedatum",
    },
    offer: {
      title: 'Angebot | Angebote',
      period: 'Angebotszeitraum'
    },
    person: {
      adult: "Erwachsener | Erwachsene",
      child: "Kind | Kinder",
      title: 'Person | Personen',
    }
  },
  mod: {
    accommodation: {
      title: 'Übernachtung',
      firstQuestion: "Wie möchten Sie übernachten?",
      message: {
        headline: 'Möchten Sie eine Mitteilung verfassen?',
        placeholder: 'Ihre Mitteilung',
        summaryTitle: 'Mitteilung'
      },
      service: {
        question: 'Welche Zusatzleistungen möchten Sie?'
      }
    },
    contact: {
      title: 'Kontaktdaten',
      salutation: 'Anrede',
      salutationOptions: [
        'Frau',
        'Herr',
        'Frau Dr.',
        'Herr Dr.',
      ],
      firstName: 'Vorname',
      lastName: 'Nachname',
      street: 'Straße und Hausnummer',
      zip: 'Postleitzahl',
      city: 'Ort',
      country: 'Land',
      countryOptions: [
        'Deutschland',
        'Österreich',
        'Schweiz',
        'Belgien',
        'Dänemark',
        'Frankreich',
        'Großbritannien',
        'Luxemburg',
        'Italien',
        'Kanada',
        'Niederlande',
        'Polen',
        'Schweden',
        'Spanien',
        'Tschechien',
        'USA',
      ],
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      availability: 'Angaben zur Erreichbarkeit',
      availabilityOptions: [
        'Abends erreichbar',
        'Vormittags erreichbar',
        'Immer erreichbar'
      ],
      errors: {
        salutation: 'Eingabe unvollständig/ungültig: Anrede',
        firstName: 'Bitte geben Sie Ihren Vornamen ein.',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein.',
        email: 'Bitte geben Sie Ihre korrekte E-Mail-Adresse ein.',
        phone: 'Bitte geben Sie Ihre Telefonnummer ein.',
        street: 'Bitte geben Sie Ihre Straße ein.',
        zip: 'Bitte geben Sie Ihre Postleitzahl ein.',
        city: 'Bitte geben Sie Ihren Ort ein.',
        country: 'Bitte geben Sie Ihre Land ein.',
        availability: 'Bitte geben Sie Ihre Verfügbarkeit an.',
      }
    },
    diverse:  {
      title: 'Ihre Anfrage',
      errors: {
        select: 'Bitte treffen Sie eine Auswahl.',
        required: 'Bitte bestätigen.'
      }
    },
    peopleConfigurator: {
      numberOfAdults: {
        decrease: 'Anzahl Erwachsene um eins reduzieren',
        increase: 'Anzahl Erwachsene um eins erhöhen',
      },
      numberOfChildren: {
        decrease: 'Anzahl Kinder um eins reduzieren',
        increase: 'Anzahl Kinder um eins erhöhen',
      },
      errors: {
        atLeastOne: "Bitte mind. eine Person auswählen.",
        ageMissing: "Bitte Alter der Kinder angeben."
      }
    },
    sidebar: {
      title: 'Empfängerdaten',
      contact: 'Kontakt',
      address: 'Adresse',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
    },
    summary: {
      title: 'Zusammenfassung & Senden',
      headline: 'Zusammenfassung',
      dataProcessing: {
        title: 'Datenverarbeitung',
        text: "Ich erkläre meine Einwilligung zur Erhebung, Verarbeitung und Nutzung\n" +
          "meiner personenbezogenen Daten nur zum Zweck der Kontaktaufnahme und Angebotserstellung\n" +
          "gemäß der Datenschutzerklärung."
      },
      privacyPolicy: {
        defaultUrl: '/datenschutz/',
        linkReplaceSearchText: 'Datenschutzerklärung',
        openLabel: 'Datenschutzerklärung öffnen',
      } ,
      emailCheck: {
        title: 'Abschließend überprüfen Sie bitte Ihre E-Mail-Adresse'
      },
      errors: {
        dataProcessing: 'Wir benötigen Ihre Einwilligung, um Ihre Daten verarbeiten zu dürfen.',
        send: {
          base: 'Hoppla! Da ist etwas schief gelaufen.',
          supportNotified: 'Der technische Support wurde informiert, bitte versuchen Sie es später erneut.',
          contactSupport: 'Bitte informieren Sie den Support und versuchen Sie es später erneut.'
        }
      },
      thankYou: {
        title: 'Anfrage gesendet',
        text: 'Vielen Dank für Ihre Anfrage! Wir melden uns in Kürze bei Ihnen.'
      }
    },
    traveldateoffer: {
      title: "Auswahl & Reisedatum",
      firstQuestion: "Welchen Wunsch haben Sie?",
      offer: {
        title: "Welches Angebot wünschen Sie?",
        readMore: "mehr Details",
      },
      message: {
        title: 'Ihre Mitteilung',
        summaryTitle: 'Mitteilung', // Nachricht?
      },
      requestType: {
        offer: "Angebot auswählen",
        message: 'Mitteilung senden',
        accommodation: "Übernachtung"
      },
      errors: {
        requestType: 'Bitte wählen Sie eine der genannten Möglichkeiten.',
        nights: 'Bitte genau {days} Tage ({nights} Übernachtungen) auswählen.',
        minNights: 'Bitte mindestens {days} Tage auswählen ({nights} Mindestübernachtungen).',
        maxNights: 'Bitte höchstens {days} Tage auswählen (maximal {nights} übernachtungen).',
        period: 'Bitte wählen Sie ein Datum im Angebotszeitraum.',
      }
    }
  },
  form: {
    action: {
      view: 'anzeigen',
      edit: 'bearbeiten',
      add: '{item} hinzufügen',
      remove: 'entfernen',
      back: 'zurück',
      next: "Weiter",
      submit: 'Anfrage senden'
    },
    hint: {
      selected: 'Ausgewählt',
      selectPrompt: "Bitte {item} auswählen",
      submitting: "Ihre Anfrage wird gesendet",
      travelDate: 'Ihr Reisedatum',
      nextDisabled: "Eingaben noch nicht stimmig. Bitte überprüfen Sie Ihre Eingaben!",
      optional: '(optional)',
      requestToSkip: 'nicht ausfüllen',
      progress: 'Fortschritt'
    }
  },
  date: {
    formatDate: "DD.MM.YYYY",
    formatDateTime: "DD.MM.YYYY - HH:mm [Uhr]",
  }
};